<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Respuestas de grafos
      b-col(md="auto")
        b-button(variant="primary" @click="createGraphAnswer", :disabled="loading") Crear respuesta
    b-form-group
      b-input-group
        b-form-input(placeholder="Buscar respuesta", type="search", v-model="search_text", :disabled="loading")
        b-input-group-append
          b-button(variant="soft-primary", :disabled="loading")
            .d-flex.align-items-center
              search-icon.icon-sm
              span.ml-2(v-if="$breakpoint.mdUp") Buscar
    .text-center
      b-spinner(variant="primary", v-if="loading")
    graph-answer(v-for="g_a in graph_answers", :key="g_a._id", :answer="g_a")
    empty-message(v-if="!graph_answers.length && !loading", message="No hay respuestas creadas")
    .d-flex.align-items-center.card-body
      b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getGraphAnswers')", v-if="!v_paginationShow")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const answersController = createNamespacedHelpers('graph_answer')
import GraphAnswer from "../../components/GraphAnswer.vue";
import _debounce from "lodash.debounce";

export default {
  data () {
    return {
      loading: false,
      busy: false,
      search_text: '',
      fields: []
    }
  },
  computed: {
    ...answersController.mapState({
      graph_answers: state => state.graph_answers
    })
  },
  methods: {
    ...mapActions(['graph_answer/all', 'graph_answer/create']),
    getGraphAnswers () {
      let self = this
      this.loading = true

      this['graph_answer/all']({
        account_id: self.$route.params.account_id,
        params: {
          text: self.search_text,
          ...self.paginationParamsObject
        },
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      })
    },
    searchGraphAnswers: _debounce(function () {
      this.resetPaginationData()
      this.getGraphAnswers()
    }, 1000, {leading: false, trailing: true}),
    createGraphAnswer () {
      let self = this
      this.loading = true
      let params = {
        account_id: self.$route.params.account_id,
        text: "Nueva respuesta de grafo"
      }

      this['graph_answer/create']({
        ...params,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
  },
  mounted () {
    this.getGraphAnswers()
  },
  watch: {
    search_text () {
      this.searchGraphAnswers()
    },
  },
  components: {GraphAnswer}
}
</script>

<style lang="scss" scoped>
</style>
